import { render, staticRenderFns } from "./PortalPanel.vue?vue&type=template&id=fbd83c84&scoped=true&"
import script from "./PortalPanel.vue?vue&type=script&lang=js&"
export * from "./PortalPanel.vue?vue&type=script&lang=js&"
import style0 from "./PortalPanel.vue?vue&type=style&index=0&id=fbd83c84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd83c84",
  null
  
)

export default component.exports